import { IPoiItem } from '../../../shop-dine-relax/domain/models/IPoiItem';
import { terminalMap } from './terminalMap';

export const findSecurityPoiId = (
	securityPoiData: IPoiItem[],
	checkpointId: string,
) => {
	const terminalInfo = terminalMap[checkpointId];

	if (!terminalInfo) {
		return undefined;
	}

	const poiId = securityPoiData.find(
		(poi) => poi.name === terminalInfo.poiName,
	)?.poiId;

	return poiId;
};
